import { createFileRoute, redirect } from "@tanstack/react-router";

// Old default: the My Cards menu lands on /mycards/upcoming.
export const Route = createFileRoute("/mycards/")({
  beforeLoad: () => {
    throw redirect({ to: "/mycards/$type", params: { type: "upcoming" } });
  },
});
